import React from 'react'
import { createRoot } from 'react-dom/client'
import 'react-toastify/dist/ReactToastify.css'
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'
import './bbraun.css'
import './index.css'
import { CookiesProvider } from 'react-cookie'
import { getItem } from './utils/localStorage'
import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

const container = document.getElementById('root')
if (!container) {
    throw new Error('Root element not found')
}

const root = createRoot(container)

const renderApplication = () => {
    root.render(
        <React.StrictMode>
            <CookiesProvider>
                <App />
            </CookiesProvider>
        </React.StrictMode>
    )
}

const token = getItem('token')
if (token) {
    Promise.resolve()
        // validate the session here
        .then(renderApplication)
        .catch(() => {
            root.render(
                <React.StrictMode>
                    <div>
                        <h1>An error occured</h1>
                    </div>
                </React.StrictMode>
            )
        })
} else {
    renderApplication()
}

// Service Worker für Offline-Funktionalität registrieren
// Nur in Production aktiviert
serviceWorkerRegistration.register({
    onSuccess: () => {
        console.log('Service Worker: Content ist für Offline-Nutzung verfügbar')
    },
    onUpdate: (registration) => {
        console.log('Service Worker: Neue Version verfügbar - automatisches Reload beim nächsten Besuch')
        // Automatisch aktivieren beim nächsten Page Load
        if (registration.waiting) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' })
        }
    }
})
